import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import DirectNavigationItem from '@/repositories/data/directnavigation/DirectNavigationItem';

export default class DirectNavigationItemRepository extends BaseCrudRepository<
    number,
    DirectNavigationItem,
    DirectNavigationItem
> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/direct-navigation-item/');
    }

    protected processBeforeCreate(user: DirectNavigationItem): DirectNavigationItem {
        user.order = -1;
        return user;
    }
}
